module.exports = __webpack_public_path__ + "static/img/pic.85b3170.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic.png
// module id = o3Ya
// module chunks = 1